module.exports = __webpack_public_path__ + "static/img/fm6.bfb0cd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fm6.jpg
// module id = fdxF
// module chunks = 1